import React from "react";

export default function DinoLoader({ darkMode }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "200px",
        color: darkMode ? "#fff" : "#222",
      }}
    >
      <img
        src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExbXVxZmE3OTcxNGZyZHB2eGRxNjJqYzg2azF4MXF3cGl1ZnRmamhhdyZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/eAYzrOtSMOKem8n3lc/giphy.gif"
        alt="Loading dinosaur"
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          marginBottom: "1rem",
        }}
      />
      <p style={{ fontSize: "1.1rem", fontWeight: 500 }}>Analyzing your data...</p>
    </div>
  );
}
